import { network } from 'services/network';

export const getUsersList = () => {
    return network.get('admin/bo/getUsersList').then((response) => response.data);
};
